// this is intentionally empty
// see docs for usage
const awsConfig = {};
export default awsConfig;
